<template>
  <main>

    <section class="seller-hero">

      <div class="container">

        <div
          class="d-flex
                 justify-content-between
                 align-items-center
                 flex-wrap
                 gap-4"
        >

          <div>

            <span class="seller-label">
              SELLER DASHBOARD
            </span>

            <h1>
              Welcome,
              {{ userName }}
            </h1>

            <p>
              Manage your inventory and
              grow your bookstore.
            </p>

          </div>

          <router-link
            to="/books/add"
            class="btn btn-light btn-lg"
          >
            + Add New Book
          </router-link>

        </div>

      </div>

    </section>

    <section class="container py-5">

      <div class="row g-4">

        <div class="col-md-6 col-xl-3">

          <div class="seller-stat">

            <span class="stat-icon">
              📚
            </span>

            <small>
              Total Books
            </small>

            <h2>
              {{ booksCount }}
            </h2>

          </div>

        </div>

        <div class="col-md-6 col-xl-3">

          <div class="seller-stat">

            <span class="stat-icon">
              🏷️
            </span>

            <small>
              Categories
            </small>

            <h2>
              {{ categoriesCount }}
            </h2>

          </div>

        </div>

        <div class="col-md-6 col-xl-3">

          <div class="seller-stat">

            <span class="stat-icon">
              💰
            </span>

            <small>
              Average Price
            </small>

            <h2>
              {{ formatPrice(averagePrice) }}
            </h2>

          </div>

        </div>

        <div class="col-md-6 col-xl-3">

          <div class="seller-stat">

            <span class="stat-icon">
              ❤️
            </span>

            <small>
              Wishlist Saves
            </small>

            <h2>
              {{ wishlistCount }}
            </h2>

          </div>

        </div>

      </div>

      <div class="mt-5">

        <div
          class="d-flex
                 justify-content-between
                 align-items-center
                 mb-4"
        >

          <div>
            <h3>
              Manage Inventory
            </h3>

            <p class="text-muted mb-0">
              Add, edit or remove books.
            </p>
          </div>

          <router-link
            to="/books"
            class="btn btn-outline-primary"
          >
            View All Books
          </router-link>

        </div>

      </div>

    </section>

  </main>
</template>

<script>
export default {
  name: 'SellerHome',

  computed: {
    userName() {
      return (
        this.$store.getters.currentUser
          ?.name || 'Seller'
      )
    },

    booksCount() {
      return this.$store.getters.booksCount
    },

    categoriesCount() {
      return (
        this.$store.getters
          .categoriesCount
      )
    },

    averagePrice() {
      return this.$store.getters
        .averagePrice
    },

    wishlistCount() {
      return (
        this.$store.getters
          .wishlistCount
      )
    }
  },

  methods: {
    formatPrice(value) {
      return new Intl.NumberFormat(
        'en-SA',
        {
          style: 'currency',
          currency: 'SAR',
          maximumFractionDigits: 0
        }
      ).format(value)
    }
  }
}
</script>

<style scoped>
.seller-hero {
  padding: 75px 0;

  color: white;

  background:
    linear-gradient(
      135deg,
      #111827,
      #0d6efd
    );
}

.seller-label {
  letter-spacing: 2px;

  font-size: 0.75rem;

  font-weight: 700;

  opacity: 0.8;
}

.seller-hero h1 {
  font-size: 3.5rem;

  font-weight: 800;

  margin: 10px 0;
}

.seller-hero p {
  font-size: 1.1rem;

  margin: 0;
  opacity: 0.85;
}

.seller-stat {
  background: white;

  border-radius: 16px;

  padding: 25px;

  box-shadow:
    0 5px 25px
    rgba(0, 0, 0, 0.06);

  transition: 0.2s;
}

.seller-stat:hover {
  transform: translateY(-4px);
}

.stat-icon {
  font-size: 2rem;

  display: block;

  margin-bottom: 12px;
}

.seller-stat small {
  color: #6c757d;
}

.seller-stat h2 {
  margin-top: 5px;

  font-weight: 700;
}
</style>